import { AirFreightEn } from "./AirFreight";
import { DomesticMarineTransportationEn } from "./DomesticMarineTransportation";
import { RailwayFreightEn } from "./DomesticRailwayFreight";
import { DomesticTransportationEn } from "./DomesticTransportation";
import { DomesticWarehousingEn } from "./DomesticWarehousing";
import { InternationalRailwayFreightEn } from "./InternationalRailwayFreight";
import { SeaFreightEn } from "./SeaFreight";
import { TankServiceEn } from "./TankService";

const en = {
  UserInterface: {
    CurrentMonth: "Current Month",
    CurrentQuarter: "Current Quarter",
    CurrentYear: "Current Year",
    OrderQuantity: "Order",
    CumulativeValue: "Cumulative value",
    OrderQuantityStatistics: "Order quantity statistics",
    MonthOnMonth: "Month on month",
    QuarterOnQuarter: "Quarter on quarter",
    YearOnYear: "Year on year",
    LoginOut: "Whether you want to logout your account?",
  },
  menu: {
    UserInterface: 'Dashboard',
    OrderInquiry: 'Tracking',
    SeaFreight: 'Ocean Freight',
    AirFreight: 'Air Freight',
    InternationalRailwayFreight: 'Railway Freight',
    DomesticRailwayFreight: 'Railway Freight',
    DomesticTransportation: 'Trucking',
    DomesticMarineTransportation: 'Multi-Transport',
    DomesticWarehousing: 'Warehousing',
    TankService: 'Tank Service',
    InvoiceInquiry: 'Invoice',
    ContractInquiry: 'Agreement',
    PointsMall: 'Gift',
    HistoricalRedemptionRecords: 'Redemption',
    EvaluationFeedback: 'Feedback',
    ServiceEvaluation: 'Evaluation',
    Feedback: 'Feedback',
    UserCenter: 'Profile',
    CompanyInformation: 'Contacts',
    ChangePassword: 'Change password'
  },
  PointsMall: {
    PointsMall: "Shop",
    RemainingPoints: "Remaining Points",
    ExchangeHistory: "Exchange History",
    IntegratingRange: "Point cost",
    All: "All",
    LowestPoints: "Lowest Points",
    HighestPoints: "Highest Points",
    Inquire: "Search",
    ClearUp: "Reset",
    ExplanationOfRules:
      "Explanation of rules: Customers can get points by commissioning the main business of any company within the group, the accumulation method of points corresponds to different points rules according to the type of business commissioned, and the invoiced amount of the order is converted into points after completion of the order and cancellation of the account, and the points are valid for a lifetime.",
    TheGifts: "Gifts",
    TheService: "Service",
    GiftExchange: "There is no gift Exchange at this time",
    InputInformation: "Input Information",
    ContactPerson: "Contact Person",
    TelephoneNumber: "Telephone Number",
    ExchangeNumber: "Exchange Number",
    DeliveryAddress: "Delivery Address",
    Remark: "Remark",
    Price: "Price",
    PointsRequired: "Points Required",
    ChooseType: "Model",
    Number: "Qty",
    Inventory: "Inventory",
    Exchange: "Buy",
    ProductDetails: "Product Details",
    Evaluation: "Review",
    AllEvaluations: "All Evaluations",
    NoEvaluation: "No Evaluation",
    MarketPrice: "Market price",
    Points: "Points",
    Over: "Over 500,000 Points",
    filledInIsCorrect:
      "Please confirm that the information filled in is correct!",
    SubmissionSuccessful:
      "Submission successful, staff will contact you within 72 hours of working days",
  },
  InvoiceInquiry: {
    InvoiceInquiry: "Invoice",
    InvoiceIssuingEntity: "Invoice Issuing Entity",
    PleaseSelect: "Please Select",
    NoData: "No Data",
    InvoiceNumber: "Invoice Number",
    PleaseEnter: "Please Enter",
    TypeOfBill: "Type Of Bill",
    All: "All",
    Yes: "Yes",
    No: "No",
    InvoiceType: "Invoice Type",
    PaymentDate: "Payment Date",
    Inquire: "Search",
    Reset: "Reset",
    ExportList: "Export",
    InvoiceTitle: "Invoice Title",
    InvoiceSettlementType: "Invoice Settlement Type",
    InvoiceDate: "Invoice Date",
    BillingPeriod: "Billing Period",
    InvoiceValue: "Invoice Value",
    CurrencyType: "Currency Type",
    AmountOfMoney: "Amount Of Money",
    ReceivableBalance: "Receivable Balance",
    ActualPaymentDate: "Actual Payment Date",
    DaysOverdue: "Days Overdue",
    PaidOrNot: "Paid Or Not",
    Operate: "Operate",
    PleaseEnterTheContent: "Please enter the content",
    Instructions: "Instructions",
    Instructions1:
      "1、The above data is the invoice situation as of the day before your current query time.",
    Instructions2:
      "2、Please note that if your company has paid the amount in the statement, it takes 1-2 days for our company to enter the account, and both parties may have time difference.",
    Instructions3:
      "3、If you have any questions about this statement, please send an email to mwarteam@mwclg.com, or call us at 021-80229869 or 021-80229861.",
    DownloadInvoice: "Download invoice",
    doubts: "Doubts",
    InvoiceDoubtsFeedback: "Invoice doubts feedback",
    FeedbackContent: "Feedback content",
    return: "return",
    BillNumber: "Bill number",
    InvoiceDetails: "Invoice details",
    ExportDetails: "Export details",
    BusinessNumber: "Business number",
    FeeName: "Fee name",
    ExpenseAlias: "Expense alias",
    price: "price",
    TaxRate: "tax rate",
    PaperInvoices: "Paper Invoices",
    ElectronicInvoice: "Electronic Invoice",
    FullElectronicInvoice: "Full Electronic Invoice",
    GeneralInvoice: "General Invoice",
    SpecialInvoice: "Special Invoice",
  },
  ContractInquiry: {
    ContractInquiry: "Agreement",
    AgreementNumber: "MW Agreement No.",
    LegalEntityOfMilkyway: "Legal Entity of Milkyway",
    CustomerAgreementNumber: "Customer Number",
    AgreementStatus: "Agreement Status",
    Valid: "Valid",
    Invalid: "Invalid",
    InCirculation: "In circulation",
    NewImportUnconfirmed: "New import unconfirmed",
    Void: "Void",
    AgreementStartDate: "Start Date",
    AgreementEndDate: "End Date",
    SelectDate: "Select Date",
    ContractList: "Agreement list",
    CompanyAgreementNumber: "MW Agreement No.",
    LegalEntity: "Legal entity",
    BusinessPartner: "Business Partner",
    AgreementSigningDate: "Agreement Signing Date",
    StartDate: "Start Date",
    EndDate: "End Date",
    NatureOfSignature: "Nature of Signature",
    ClientAgreementNumber: "Client Agreement No.",
    UploadFile: "Upload file",
    AutoRenewal: "Auto Renewal",
    RelatedCustomers: "Related customers",
  },
  HistoricalRedemptionRecords: {
    ProductName: "Product Name",
    OrderNumber: "Order Number",
    OrderStatus: "Order Status",
    ProductSpecification: "Product Specification",
    Quantity: "Quantity",
    UsePoints: "Use Points",
    ContactPerson: "Contact Person",
    TelephoneNumber: "Telephone Number",
    DeliveryAddress: "Delivery Address",
    CourierNumber: "Courier Number",
    DeliveredOrNot: "Delivered Or Not",
    Note: "Note",
    Operate: "Operate",
    logisticsInformation: "logistics information",
    Evaluation: "Evaluation",
    Canceled: "Canceled",
    Submitted: "Submitted",
    Processing: "Processing",
    Finished: "Finished",
    ProductEvaluation: "Product Evaluation",
    QualityOfService: "Quality of Service",
    EvaluationContent: "Evaluation content",
    ProductQuality: "The product quality has not been rated yet",
    ServiceQuality: "The service quality has not been rated yet",
    logisticsQuality: "The logistics quality has not been rated yet",
    EvaluationSuccessful: "Evaluation successful",
    EvaluationFailed: "Evaluation failed, please try again later",
    Welcome: "Welcome!",
  },
  ServiceEvaluation: {
    ServiceEvaluation: "Service Evaluation",
    EvaluationFeedback: "Feedback",
    EvaluationQuery: "Evaluation query",
    EvaluatedPerson: "Milkyway employee",
    Position: "Position",
    CustomerService: "Customer service",
    Sales: "Sales",
    Department: "Department",
    Evaluator: "Your Name",
    EvaluationList: "Evaluation List",
    NewEvaluation: "Add New",
    utterance:
      "Thank you for your business support! In order to implement our company's “customer-centric” philosophy and effectively understand the quality of the work of our employees currently providing services to your company, we would like to invite your company to evaluate our services.",
    EvaluationPersonnelPositions: "Evaluation personnel positions",
    EvaluatorEmail: "Your Email",
    ServiceAttitude: "Service attitude",
    TimelyResponse: "Timely response",
    BusinessCapability: "Business capability",
    ProfessionalCompetence: "Professional competence",
    Feedback: "Feedback",
    Cancel: "Cancel",
    Confirm: "Submit",
    Score: "Score",
    Advice: "Advice",
    EvaluationTime: "Evaluation Time",
    notQueried: "This employee was not found",
  },
  Feedback: {
    Feedback: "Feedback",
    FeedbackList: "Feedback List",
    NewFeedback: "New Feedback",
    FeedbackType: "Category",
    BusinessCategory: "Business",
    ServiceCategory: "Service",
    SecurityCategory: "Security",
    OtherCategories: "Other",
    SuggestedContent: "Suggestion",
    SubmissionDate: "Submission time",
  },
  CompanyInformation: {
    CompanyInformation: "Contacts",
    ContactName: "Contact Name",
    Name: "Name",
    Position: "Position",
    Email: "E-mail",
    OfficePhoneNumber: "Office phone number",
    MobileTelephone: "Mobile telephone",
    ProvincesCitiesAndDistricts: "Provinces, cities, and districts",
    DetailedAddress: "Detailed address",
    QQNumber: "QQ number",
    WeChatAccount: "WeChat account",
    Remarks: "Remarks",
    Operation: "Operation",
    Modify: "Modify",
    Delete: "Delete",
    AddContactPerson: "Add contact person",
    Ms: "Ms.",
    Mr: "Mr.",
    Miss: "Miss",
    Unknown: "Unknown",
    Save: "Save",
    deleteContacts: "Do you want to delete contacts?",
    Loading: "Loading",
    ContactPersonInformation: "Contact Person Information",
    YourPhoneNumber: "Please enter your phone number",
    DigitPhoneNumber: "Please enter an 11 digit phone number",
    LandlinePhoneNumber: "Please enter the office landline phone number",
    CodePhoneNumber:
      'Please enter "Area Code Phone Number", for example: 021-80228498',
  },
  ChangePassword: {
    ChangePassword: "Change password",
    Account: "Account",
    SendVerificationCode: "Send verification code",
    VerificationCode: "Verification code",
    NewPassword: "New password",
    ConfirmPassword: "Confirm password",
    Submit: "Submit",
    loginAccount: "Please enter your login account",
    EmailAddress: "Please enter the email address associated with your account",
    CaptchaCode: "Please enter the 6-digit email captcha code",
    EnterNewPassword: "Please enter the new password",
    NewPasswordAgain: "Please enter the new password again",
    Reset: "Reset",
    Edit: "Edit",
    Inconsistent: "The password entered twice is inconsistent",
    CodeHasBeenSent:
      "The verification code has been sent, please log in to the email address associated with your account to view",
    PleaseLogInAgain: "Please log in again",
    ForgotPassword: "Forgot Password",
    Continue: "Continue?",
    Prompt: "Prompt",
    LoginInvalid: "Login is invalid, please log in again",
    error: "Error",
  },
  AirFreight: AirFreightEn,
  DomesticMarineTransportation: DomesticMarineTransportationEn,
  RailwayFreight: RailwayFreightEn,
  DomesticTransportation: DomesticTransportationEn,
  DomesticWarehousing: DomesticWarehousingEn,
  InternationalRailwayFreight: InternationalRailwayFreightEn,
  SeaFreight: SeaFreightEn,
  TankService: TankServiceEn,
};

export default en;
